import { NextResponse } from 'next/server'
import { query, queryOne, uuid } from '@/lib/db'

export async function POST(req: Request) {
  const { shop_id, user_id, lignes, total, montant_encaisse } = await req.json()
  // montant_encaisse = cash réellement reçu (peut être < total si kardé)
  const today = new Date().toISOString().split('T')[0]

  // Get or create caisse session
  let session = await queryOne<any>(
    'SELECT id FROM caisse_sessions WHERE shop_id = ? AND date = ?',
    [shop_id, today]
  )
  if (!session) {
    const sid = uuid()
    await query(
      'INSERT INTO caisse_sessions (id, shop_id, user_id, date, solde_ouverture) VALUES (?, ?, ?, ?, 0)',
      [sid, shop_id, user_id, today]
    )
    session = { id: sid }
  }

  // Create vente
  const venteId = uuid()
  const encaisse = montant_encaisse ?? total  // si pas précisé, tout est encaissé
  await query(
    'INSERT INTO ventes (id, shop_id, caisse_session_id, user_id, total, montant_encaisse) VALUES (?, ?, ?, ?, ?, ?)',
    [venteId, shop_id, session.id, user_id, total, encaisse]
  )

  // Insert lignes + update stock
  for (const ligne of lignes) {
    await query(
      'INSERT INTO vente_lignes (id, vente_id, article_id, quantite, prix_unitaire, ras_mel_unitaire) VALUES (?, ?, ?, ?, ?, ?)',
      [uuid(), venteId, ligne.article_id, ligne.quantite, ligne.prix_unitaire, ligne.ras_mel_unitaire]
    )
    await query(
      'UPDATE articles SET stock = stock - ?, updated_at = NOW() WHERE id = ?',
      [ligne.quantite, ligne.article_id]
    )
    await query(
      'INSERT INTO stock_mouvements (id, shop_id, article_id, user_id, type, quantite, prix_unitaire) VALUES (?, ?, ?, ?, ?, ?, ?)',
      [uuid(), shop_id, ligne.article_id, user_id, 'vente', -ligne.quantite, ligne.prix_unitaire]
    )
  }

  return NextResponse.json({ id: venteId })
}
